import { Component, OnInit, Inject } from '@angular/core';
import { take, finalize } from 'rxjs/operators';

import { OptionOrderService } from '@shared/services/option-order/option-order.service';
import { Router } from '@angular/router';
import { OrderMapped } from '@shared/services/order/_interfaces_/order.mapped.interface';
import { CommonOrderService } from '@pages/common-order/common-order.service';
import { OrderListItem } from '@pages/common-order/_interfaces_/order.interface';
import { UrlPathnameEnum } from '@enums/url-pathname.enum';

@Component({
  selector: 'app-order-options',
  templateUrl: './order-options.component.html',
})
export class OrderOptionsComponent implements OnInit {
  orderOptions: OrderListItem[];
  loading: boolean = true;

  constructor(@Inject(CommonOrderService) private _commonOrderService: CommonOrderService, @Inject(Router) private _router: Router) {}

  ngOnInit(): void {
    this._commonOrderService
      .getOptionOrders()
      .pipe(
        take(1),
        finalize(() => (this.loading = false))
      )
      .subscribe((data) => (this.orderOptions = data));
  }

  onOrderClick(row: OrderListItem): void {
    this._router.navigate([UrlPathnameEnum.CommonOrder, row.orderNumber]);
  }

  get hasOrderOptions(): boolean {
    return this.orderOptions?.length > 0;
  }
}
